import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import "./i18n";
import CareGiverContextProvider from "./context/CareGiverContext.jsx";
import AppContextProvider from "./context/AppContext.jsx";
import { ThemeProvider } from "./context/ThemeContext";

createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <ThemeProvider>
      <CareGiverContextProvider>
        <AppContextProvider>
          <App />
        </AppContextProvider>
      </CareGiverContextProvider>
    </ThemeProvider>
  </BrowserRouter>
);
